import React from "react";
import { links } from "../../config/links";

interface RodapeProps {
  onOpenModal: () => void;
}

const Rodape: React.FC<RodapeProps> = ({ onOpenModal }) => (
  <footer className="bg-soil">
    <div className="mx-auto max-w-site px-5 lg:px-8">
      <div className="grid gap-10 border-b border-soil-600/50 py-14 lg:grid-cols-[1.2fr_1fr_1fr_1fr] lg:gap-12">
        <div>
          <img src="/logo.png" alt="App Agro Negócios" className="h-11 w-auto" />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/55">
            Marketplace do agronegócio. O produtor vê o preço, compra na hora e
            acompanha o pedido em tempo real até a fazenda.
          </p>
        </div>

        <div>
          <p className="eyebrow-light">Produtor</p>
          <ul className="mt-4 space-y-2.5">
            <li>
              <a href="#produtor" className="inline-flex min-h-[2.5rem] items-center text-sm text-white/65 transition-colors hover:text-white">
                O que dá para fazer
              </a>
            </li>
            <li>
              <a href="#pagamento" className="inline-flex min-h-[2.5rem] items-center text-sm text-white/65 transition-colors hover:text-white">
                Pagamento
              </a>
            </li>
            <li>
              <a href="#perguntas" className="inline-flex min-h-[2.5rem] items-center text-sm text-white/65 transition-colors hover:text-white">
                Dúvidas
              </a>
            </li>
            <li>
              <button
                onClick={onOpenModal}
                className="inline-flex min-h-[2.5rem] items-center text-left text-sm text-white/65 transition-colors hover:text-white"
              >
                Quero o app
              </button>
            </li>
          </ul>
        </div>

        <div>
          <p className="eyebrow-light">Parceiro</p>
          <ul className="mt-4 space-y-2.5">
            <li>
              <a href="#parceiro" className="inline-flex min-h-[2.5rem] items-center text-sm text-white/65 transition-colors hover:text-white">
                Como funciona
              </a>
            </li>
            <li>
              <a href={links.partnerSignup} className="inline-flex min-h-[2.5rem] items-center text-sm text-white/65 transition-colors hover:text-white">
                Cadastrar empresa
              </a>
            </li>
            <li>
              <a href={links.terms} className="inline-flex min-h-[2.5rem] items-center text-sm text-white/65 transition-colors hover:text-white">
                Termos de uso
              </a>
            </li>
            <li>
              <a href={links.privacy} className="inline-flex min-h-[2.5rem] items-center text-sm text-white/65 transition-colors hover:text-white">
                Política de privacidade
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="eyebrow-light">Contato</p>
          <ul className="mt-4 space-y-2.5">
            <li>
              <a href={links.phoneHref} className="num inline-flex min-h-[2.5rem] items-center text-sm text-white/65 transition-colors hover:text-white">
                {links.phoneDisplay}
              </a>
            </li>
            <li>
              <a href={`mailto:${links.email}`} className="inline-flex min-h-[2.5rem] items-center break-all text-sm text-white/65 transition-colors hover:text-white">
                {links.email}
              </a>
            </li>
            <li>
              <a href={links.instagram} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-[2.5rem] items-center text-sm text-white/65 transition-colors hover:text-white">
                Instagram
              </a>
            </li>
            <li className="text-sm text-white/40">Rondonópolis, MT</li>
          </ul>
        </div>
      </div>

      <div className="flex flex-wrap items-center justify-between gap-4 py-7">
        <p className="font-mono text-[0.6875rem] uppercase tracking-[0.14em] text-white/35">
          App Agro Negócios
        </p>
        <p className="text-xs text-white/35">
          Todos os direitos reservados
        </p>
      </div>
    </div>
  </footer>
);

export default Rodape;
